
document.body.addEventListener('click', function (event) {
  var element = event.target;
  if (element.hasClass('reply_com')) appendReplyForm(element);
  if (element.hasClass('send_com')) sendComment(element);
  if (element.hasClass('send_subcom')) sendSubcom(element);
});


document.addEventListener('input', function (event) {
  if (event.target.classList.contains('auto-area')) {
    event.target.style.height = 'auto';
    event.target.style.height = event.target.scrollHeight + 'px';
  }
});

function appendReplyForm(el) {
  var itemBox = el.closest('.com_item_box');
  var frameSubcom = itemBox.querySelector('.frame-subcom');
  if (!frameSubcom) {
    itemBox.insertAdjacentHTML("beforeend", '<div class="frame-subcom"><div class="sub-comments"></div></div>');
    frameSubcom = itemBox.querySelector('.frame-subcom');
  }
  var commentForm = frameSubcom.querySelector('.comment-form');
  if (!commentForm) {
    var avatarTag = document.querySelector('[data-user-fullname]');
    var userPath = avatarTag.getAttribute('src');
    var htmlTemp = window.subcomFormTemplate;
    htmlTemp = htmlTemp.replace('images/avatar01.jpg', userPath);
    frameSubcom.insertAdjacentHTML("beforeend", htmlTemp);
    commentForm = frameSubcom.querySelector('.comment-form');
  }
  commentForm.querySelector('textarea').focus();
}

function sendComment(el) {
  var frame = el.closest('.frame-comment');
  var commentForm = el.closest('.comment-form');
  if (commentForm && commentForm.getAttribute('data-no-comment-post') === '1') {
    return;
  }
  const textarea = commentForm.querySelector('.post_com');
  var text = textarea.value.trim();
  const formatted = text.replace(/\n/g, '<br>');
  if (text === '') { return; }
  console.log("Send message:", text);

  var dataPost = { content: formatted };
  var frameTag = frame.closest('[data-comment-id]');
  if (frameTag) {
    dataPost.parentId = frameTag.getAttribute('data-comment-id');
  }
  dataPost.providerId = document.querySelector('#ProviderId').value;
  var postUrl = document.querySelector('#CommentUrl').value;
  postApi(postUrl, dataPost);

  textarea.value = "";
  textarea.dispatchEvent(new Event('input', { bubbles: true }));

  var list = frame.querySelector('.frame-comments');

  if (!list) {
    frame.insertAdjacentHTML("afterbegin", '<div class="frame-comments"></div>');
    list = frame.querySelector('.frame-comments');
  }
  var avatarTag = document.querySelector('[data-user-fullname]');
  var fullname = avatarTag.getAttribute('data-user-fullname');
  var userPath = avatarTag.getAttribute('src');
  var htmlTemp = window.commentTemplate;

  htmlTemp = htmlTemp.replace('TextHolder', formatted);
  htmlTemp = htmlTemp.replace('AvatarPathHolder', userPath);
  htmlTemp = htmlTemp.replace('FullnameHolder', fullname);

  list.insertAdjacentHTML("beforeend", htmlTemp);
  list.scrollTop = list.scrollHeight;
}

function sendSubcom(el) {
  var frame = el.closest('.frame-subcom');
  var commentForm = el.closest('.comment-form');
  const textarea = commentForm.querySelector('.post_com');
  var text = textarea.value.trim();
  const formatted = text.replace(/\n/g, '<br>');
  if (text === '') { return; }
  console.log("Send message:", text);

  var dataPost = { content: formatted };
  var frameTag = frame.closest('[data-comment-id]');
  if (frameTag) {
    dataPost.parentId = frameTag.getAttribute('data-comment-id');
  }
  dataPost.providerId = document.querySelector('#ProviderId').value;
  var postUrl = document.querySelector('#CommentUrl').value;
  postApi(postUrl, dataPost);

  textarea.value = "";
  textarea.dispatchEvent(new Event('input', { bubbles: true }));

  var list = frame.querySelector('.sub-comments');

  var avatarTag = document.querySelector('[data-user-fullname]');
  var fullname = avatarTag.getAttribute('data-user-fullname');
  var userPath = avatarTag.getAttribute('src');
  var htmlTemp = window.subcomTemplate;

  htmlTemp = htmlTemp.replace('TextHolder', formatted);
  htmlTemp = htmlTemp.replace('AvatarPathHolder', userPath);
  htmlTemp = htmlTemp.replace('FullnameHolder', fullname);

  list.insertAdjacentHTML("beforeend", htmlTemp);
  list.scrollTop = list.scrollHeight;
}
function postApi(url, data) {
  data.url = url;
  console.log(data);
  const fullHeaders = {
    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    Accept: "application/json",
    'Content-Type': 'application/json'
  };
  fetch(url, {
    method: 'POST',
    headers: fullHeaders,
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => {
    console.log('Success:', data);
  })
  .catch(error => {
    console.error('Error:', error);
  });
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
